/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel } from './MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel';
import {
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelFromJSON,
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelFromJSONTyped,
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelToJSON,
} from './MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel';

/**
 * 
 * @export
 * @interface MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus
 */
export interface MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus {
    /**
     * 
     * @type {MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel}
     * @memberof MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus
     */
    label: MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel;
}

/**
 * Check if a given object implements the MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus interface.
 */
export function instanceOfMondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus(value: object): value is MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusFromJSON(json: any): MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus {
    return MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusFromJSONTyped(json, false);
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'label': MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelFromJSON(json['label']),
    };
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusToJSON(value?: MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelToJSON(value['label']),
    };
}

